/* eslint-disable import/no-anonymous-default-export */
export default (location = [], action) => {
  switch (action.type) {
    case "STOCK_LOCATION":
      return action.payload;

    case "CREATE_STOCK_LOCATION":
      return [...location, action.payload];

    case "UPDATE_LOCATION":
      return location.map((d) => (d._id === action.payload?._id ? action.payload : d));

    case "DELETE_STOCK_LOCATION":
      return location.filter((data) => data._id !== action.payload);

    default:
      return location;
  }
};
